//@ts-ignore
//@ts-nocheck
import CheckCircleIcon from "@mui/icons-material/CheckCircle";
import ErrorIcon from "@mui/icons-material/Error";
import { Fragment, useEffect, useState } from "react";
import { ConnectedProps, connect } from "react-redux";
import { useNavigate, useSearchParams } from "react-router-dom";
import MarkLogoWhite from "../../assets/images/MarkLogo.png";
import { RootState } from "../../stores/AppReducers";
import GlobalLoadingActions from "../../stores/GlobalLoading/Actions";
import {
  Container,
  FormContainer,
  LeftContainer,
  LogoImg,
  RightContainer,
} from "./styles/Payment-ConfirmationStyles";
import COLORS from "../../theme/Colors";
import { validatePaymentBySessionCode } from "../../api/PaymentConfirmation";
import { StyledButton } from "../../theme/Styles";
import HotelOfferLogos from "../../assets/images/HotelOfferLogos.webp";

function PaymentConfirmation(props: ScreenProps) {
  let navigate = useNavigate();
  let [searchParams] = useSearchParams();
  const sessionCode = searchParams.get("session");
  const [status, setStatus] = useState<boolean | undefined>();
  const handlePaymentValidation = async () => {
    try {
      const response = await validatePaymentBySessionCode(sessionCode);
      if (response.ok) {
        setStatus(true);
      } else {
        setStatus(false);
      }
    } catch (error) {
      setStatus(false);
    }
  };

  /* Componentdidmount */
  useEffect(() => {
    /* from params cases */
    if (sessionCode !== null) {
      handlePaymentValidation();
    }
  }, []);

  return (
    <Container>
      <LeftContainer>
        <LogoImg src={MarkLogoWhite} />
      </LeftContainer>
      <RightContainer>
        <FormContainer>
          {status === undefined ? (
            <h1>Validando...</h1>
          ) : status === false ? (
            <Fragment>
              <ErrorIcon
                fontSize="large"
                sx={{ color: COLORS.error, fontSize: "10rem" }}
              />
              <h1>Ha ocurrido un error al validar su pago.</h1>
              <br />
              <StyledButton onClick={() => navigate("/payment")}>
                Reintentar Pago
              </StyledButton>
              <br />
            </Fragment>
          ) : (
            <Fragment>
              <CheckCircleIcon
                fontSize="large"
                sx={{ color: COLORS.success, fontSize: "10rem" }}
              />
              <h1>Pago realizado satisfactoriamente.</h1>
              <br />
              {/*   <span>
                al pagar tu reserva en el Hotel The Westin Puntacana Resort &
                Club con tus{" "}
                <strong>
                  Tarjetas de Crédito personales Mastercard Banreservas,
                </strong>
                para tu estadía del 5 al 7 de junio 2025.
                <br /> <br />
                Tope máximo de devolución <strong>US$250</strong> por cliente.
                La devolución será realizada por cliente en julio 2025.
                <br /> <br />
              </span> */}
              <img
                style={{ width: "100%", height: "auto" }}
                src={HotelOfferLogos}
                alt="hotel cashback"
              />

              <br />
              <StyledButton
                onClick={() =>
                  window.open(
                    "https://marriott.com/es/event-reservations/reservation-link.mi?id=1773681121586&key=GRP&guestreslink2=true&app=resvlink",
                    "_blank",
                  )
                }
              >
                ¡Reserva ahora!
              </StyledButton>
              <br />
            </Fragment>
          )}
        </FormContainer>
      </RightContainer>
    </Container>
  );
}

interface ScreenProps extends ReduxProps {}

const mapStateToProps = (state: RootState) => ({
  user: state.signin.user,
});

const mapDispatchToProps = {
  showGlobalLoading: GlobalLoadingActions.showGlobalLoading,
  hideGlobalLoading: GlobalLoadingActions.hideGlobalLoading,
};

const connector = connect(mapStateToProps, mapDispatchToProps);
type ReduxProps = ConnectedProps<typeof connector>;

export default connector(PaymentConfirmation);
